export const STATIC_CONTENT_TYPE = [
  { name: "PRIVACY POLICY", type: 1, id: "69e87a1dde20d6e9a4471cbd" },
  { name: "TERMS AND CONDITIONS", type: 2, id: "69e87a39de20d6e9a4471cc2" },
  { name: "CONTACT US", type: 3, id: "69e87a49de20d6e9a4471cc7" },
  { name: "FAQ", type: 4, id: "69e87a52de20d6e9a4471ccc" },
];

export const DIVE_TYPES = {
  Wreck: "wreck",
  Reef: "reef",
  Cave: "cave",
  Ice: "ice",
  Rescue: "rescue",
  Technical: "technical",
  Exploration: "exploration",
};

export const FeedbackStatus = {
  Pending: "1",
  Completed: "4",
};

export const MAX_FILE_SIZE_MB = 200;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_TYPES = [
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video/quicktime",
];

export const EMAIL_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const EMAIL_STATUS_CONFIG = {
  [EMAIL_STATUS.ACTIVE]: {
    label: "Active",
    color: "success",
  },
  [EMAIL_STATUS.INACTIVE]: {
    label: "Inactive",
    color: "danger",
  },
};

export const AllowedImageTypes = ".jpg,.jpeg,.png,image/jpeg,image/png";
export const AllowedVideoTypes = ".mp4, video/mp4";

export const FOLDER_TYPE = {
  PROFILE_PICTURE: 1,
  POST_PICTURE: 2,
  POST_VIDEO: 3,
  SITE_PICTURE: 4,
  MARINE_LIFE_CATEGORY: 5,
  RECEIPT: 6,
  DIVE_LOG: 7,
  FEEDBACK: 8,
  TRIP_PLANNER_IMAGES: 9,
  ARTICLE_IMAGE: 10,
  ARTICLE_VIDEO: 11,
  HOW_TO_VIDEO: 12,
  HOW_TO_VIDEO_THUMBNAIL: 13,
};

export const ARTICLE_STATUS = {
  DRAFT: 1,
  PUBLISHED: 2,
};

export const ARTICLE_STATUS_OPTIONS = [
  { label: "Draft", value: ARTICLE_STATUS.DRAFT, variant: "draft" },
  { label: "Published", value: ARTICLE_STATUS.PUBLISHED, variant: "published" },
];

export const HOW_TO_VIDEO_STATUS = {
  DRAFT: 1,
  PUBLISHED: 2,
};

export const HOW_TO_VIDEO_STATUS_OPTIONS = [
  { label: "Draft", value: HOW_TO_VIDEO_STATUS.DRAFT, variant: "draft" },
  {
    label: "Published",
    value: HOW_TO_VIDEO_STATUS.PUBLISHED,
    variant: "published",
  },
];

export const ARTICLE_FIELD_LIMITS = {
  TITLE_MAX: 100,
  DESCRIPTION_MAX: 500,
  READ_TIME_MAX: 60,
  TAG_MAX_LENGTH: 30,
  TAGS_MAX_COUNT: 10,
  CONTENT_MAX: 2000,
};

export const REVIEW_STATUS = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const REVIEW_RATING = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
};

export const REVIEW_STATUS_OPTIONS = [
  { label: "Pending", value: REVIEW_STATUS.PENDING },
  { label: "Approved", value: REVIEW_STATUS.APPROVED },
  { label: "Rejected", value: REVIEW_STATUS.REJECTED },
];

export const REVIEW_RATING_OPTIONS = [
  { label: "1", value: REVIEW_RATING.ONE },
  { label: "2", value: REVIEW_RATING.TWO },
  { label: "3", value: REVIEW_RATING.THREE },
  { label: "4", value: REVIEW_RATING.FOUR },
  { label: "5", value: REVIEW_RATING.FIVE },
];

export const MAX_VIDEO_SIZE_MB = 100;
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

export const MAX_IMAGE_SIZE_MB = 2;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export const EMAIL_VARIABLES = {
  NAME: "{{name}}",
  EMAIL: "{{email}}",
  DESCRIPTION: "{{description}}",
  OTP: "{{otp}}",
  TRIP_ADMIN: "{{tripAdmin}}",
  POST_TITLE: "{{postTitle}}",
};

export const EMAIL_VARIABLES_OPTIONS = [
  EMAIL_VARIABLES.NAME,
  EMAIL_VARIABLES.EMAIL,
  EMAIL_VARIABLES.DESCRIPTION,
  EMAIL_VARIABLES.OTP,
  EMAIL_VARIABLES.TRIP_ADMIN,
  EMAIL_VARIABLES.POST_TITLE,
];

export const HOW_TO_USE_STATUS = {
  DRAFT: 1,
  PUBLISHED: 2,
};

export const HOW_TO_USE_STATUS_OPTIONS = [
  { label: "Draft", value: HOW_TO_USE_STATUS.DRAFT, variant: "draft" },
  {
    label: "Published",
    value: HOW_TO_USE_STATUS.PUBLISHED,
    variant: "published",
  },
];

export const HOW_TO_USE_STATUS_LABELS = {
  [HOW_TO_USE_STATUS.DRAFT]: "Draft",
  [HOW_TO_USE_STATUS.PUBLISHED]: "Published",
};
